<template>
    <div class="map-instruction" :class="{'clamp-lines': !noLineClamp, 'dynamic-font-size': dynamicFontSize, 'long-instruction': isLongInstruction, 'very-long-instruction': isVeryLongInstruction}">
        <span v-if="mapInstruction?.showDistance && mapInstruction?.nextInstruction?.distance">
            {{ mapInstruction.action }} {{ formatDistance(mapInstruction.nextInstruction.distance) }}
        </span>
        {{ mapInstruction?.description }}
        <b v-if="mapInstruction?.nextLocation" class="highlight">
            {{ mapInstruction.nextLocation }}
        </b>
        <div v-if="!noOptionalInstructions && mapInstruction?.instructions" class="mt-1">
            <b-badge v-if="mapInstruction.instructionGlyph" pill class="instruction-glyph text-white">
                <i :class="[fontAwesomePrefix, mapInstruction.instructionGlyph]"/>
            </b-badge>
            <span v-if="mapInstruction.instructions">
                {{mapInstruction.instructions}}
            </span>
        </div>
        <slot name="after"/>
    </div>
</template>

<script>
import {formatDistance as helperFormatDistance} from "@/helpers/DistanceHelper.js";

export default {
    name: "map-instruction",
    props: {
        mapInstruction: {type: Object, required: true},
        noLineClamp: {type: Boolean},
        noOptionalInstructions: {type: Boolean},
        dynamicFontSize: {type: Boolean}
    },
    computed: {
        instructionTextLength() {
            const instruction = this.mapInstruction;
            if (!instruction) {
                return 0;
            }

            const parts = [];

            if (instruction.showDistance && instruction.nextInstruction?.distance) {
                parts.push(instruction.action, this.formatDistance(instruction.nextInstruction.distance));
            } else {
                parts.push(instruction.action);
            }

            parts.push(instruction.description, instruction.nextLocation);

            if (!this.noOptionalInstructions) {
                parts.push(instruction.instructions);
            }

            return parts.filter(Boolean).join(` `).replace(/\s+/g, ` `).trim().length;
        },
        isLongInstruction() {
            return this.instructionTextLength > 48;
        },
        isVeryLongInstruction() {
            return this.instructionTextLength > 65;
        }
    },
    methods: {
        formatDistance(value) {
            return helperFormatDistance(value, { style: `spaced` });
        }
    }
}
</script>

<style lang="scss">
.map-instruction {
    font-size: 14pt;
    font-weight: 500;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-wrap: pretty;
    line-height: normal;

    &.clamp-lines {
        line-clamp: var(--map-mobile-nav-instruction-lines, 2);
        -webkit-line-clamp: var(--map-mobile-nav-instruction-lines, 2);
    }

    &.dynamic-font-size {
        font-size: min(14pt, clamp(14pt, 5.4cqi, 14pt));
    }

    &.dynamic-font-size.long-instruction {
        font-size: min(13pt, clamp(13pt, 5cqi, 12.5pt));
    }

    &.dynamic-font-size.very-long-instruction {
        font-size: min(12pt, clamp(12pt, 4.5cqi, 11.5pt));
    }

    .highlight {
        color: var(--color-accent);
    }

    .instruction-glyph {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: var(--orange);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }
}

// Dark theme for top nav
.nav-dark-theme {
    .map-instruction {
        .highlight {
            color: #31ccfc;
        }
    }
}
</style>
